function getParentPageUrl() {
  if (!window.location.hash) return null;

  let hash;

  try {
    hash = decodeURI(window.location.hash.substring(1));
  } catch (_err) {
    // Malformed URI for some reason
    return null;
  }

  const URLFragment = JSON.parse(hash);

  return URLFragment.parentPageUrl;
}

export { getParentPageUrl };
